import { resolveReferencePriceDisplay } from '@/wabunka-src/common/features/Experience/models/referencePriceDisplay';

import type { WabunkaExperience } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience';

export type ExperienceDisplayPrice = { kind: 'private' } | { kind: 'priced'; amount: number; currency: string };

// 外貨で換算価格が無いときは JPY の額を出さず非表示にする（詳細ページは JPY にフォールバックする）。
export const buildExperienceDisplayPrice = (experience: Pick<WabunkaExperience, 'isPublicPrice' | 'referencePrice' | 'currencyConvertedPrice'>, currency: string): ExperienceDisplayPrice | undefined => {
  const display = resolveReferencePriceDisplay(experience);

  switch (display.kind) {
    case 'private':
      return { kind: 'private' };
    case 'unpriced':
      return undefined;
    case 'converted':
      return { kind: 'priced', amount: display.amount, currency: display.currency };
    case 'jpy':
      return currency === 'JPY' ? { kind: 'priced', amount: display.amount, currency } : undefined;
  }
};
